import React from "react";
import ErrorMessage from "./errorMessage";

function Index() {
  return <ErrorMessage />;
}

export default Index;
